import { Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import * as React from "react";

export default function EventHeader({
  label = "Upcoming Events",
  align = "left",
}) {
  return (
    <GreyText gutterBottom align={align}>
      {label}
    </GreyText>
  );
}

EventHeader.propTypes = {
  label: PropTypes.string,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

const GreyText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.interFontStack,
  fontSize: theme.typography.pxToRem(12),
  color: theme.palette.grey.mid,
}));
